import type { tProductPreview } from 'src/shared/frontendTypes/product'

export type ListingResult = { products: tProductPreview[]; count?: number }

/** A preview is only a temporary first page, never a total or a cached full page. */
export const listingPresentation = ({
  complete, preview, server, canUsePreview, canUseServer, failed,
}: {
  complete?: ListingResult
  preview?: ListingResult
  server?: ListingResult
  canUsePreview: boolean
  canUseServer: boolean
  failed: boolean
}) => {
  if (complete) return { ...complete, loading: false }
  if (canUsePreview && preview?.products.length) return { products: preview.products, count: undefined, loading: !failed }
  if (canUseServer && server) return { ...server, loading: false }
  return { products: [] as tProductPreview[], count: undefined, loading: !failed }
}
